import { getTransformedFixture } from '../helpers/fixtureUtils';

class FixtureService {
  constructor(sportsManager) {
    this.fixture = null;
    this.sportsManager = sportsManager;
    this.jsonManager = this.sportsManager.jsonManager;
    this.eventManager = this.sportsManager.eventManager;
    this.dataManager = sportsManager.dataManager;
  }

  async getFixture(sportsId, tournamentId, fixtureStatus, pageNum, eventName, jsonConfig,callback) {
    this.jsonManager.fetchJSONData(sportsId, tournamentId, fixtureStatus, pageNum, jsonConfig).then((fixtureData) => {
      const fixtureWidgetData = getTransformedFixture(
        fixtureData?.tour_details ?
            fixtureData?.tour_details?.[0][fixtureStatus || this.JSONConfig.status]?.[0]?.matches || []
          : fixtureData || []
      );
      let tourName = fixtureData?.tour_details?.[0]?.tour_name
      let tourMetaData = fixtureData?.tour_details?.[0]?.tour_metadata;
      let loadedPageNumber = fixtureData?.tour_details?.[0][fixtureStatus || this.JSONConfig.status]?.[0]?.page_no;
      let totalPages = fixtureData?.tour_details?.[0][fixtureStatus || this.JSONConfig.status]?.[0]?.total_page;
      const fixtureDropdownData = fixtureData?.tour_details?.map((tour) => {
        return {
          tourId: tour.tour_id,
          tourName: tour.tour_name,
        };
      });
      this.eventManager.broadcastPrivateEvent(eventName, { fixtureWidgetData, fixtureDropdownData, loadedPageNumber, totalPages, tourMetaData, callback, tourName });
      // this.eventManager.broadcastPrivateEvent(eventName, { fixtureWidgetData, fixtureDropdownData, loadedPageNumber, totalPages, callback });
      this.dataManager.addData(
        'FixtureService',
        'fixtures',
        { sportsId, tournamentId, fixtureStatus, pageNum },
        { fixtureWidgetData, fixtureDropdownData, loadedPageNumber, totalPages, tourMetaData, callback, tourName }
        // { fixtureWidgetData, fixtureDropdownData, loadedPageNumber, totalPages, callback }

      );
      // if(typeof callback == 'function') {
      //   callback()
      // }
    });
  }

  fetchFixtureData(sportsId, tournamentId, fixtureStatus, pageNum, eventName, jsonConfig,callback) {
    this.getFixture(sportsId, tournamentId, fixtureStatus, pageNum, eventName, jsonConfig,callback);
  }
}

export default FixtureService;
